var map = {
	"./so-1-ed.png": 4814,
	"./so-2-ed.png": 8198,
	"./so-3-ed.png": 4277,
	"./so-4-ed.png": 2394,
	"./so-5-ed.png": 2137,
	"./so-6-ed.png": 9428,
	"./so-7-ed.png": 4996,
	"./so-8-ed.png": 969,
	"./so-9-ed.png": 8943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8981;